import type { ICountry } from '@/api/common';
import { DEFAULT_LICENSE } from '@/modules/license/constants';
import { normalizeLicense } from '@/modules/license/helpers';
import { License } from '@/store/commonStore/types';
import { Country } from './conf';

export const DEFAULT_COUNTRIES: ICountry[] = [
  {
    name: 'Argentina',
    code: Country.Argentina,
    defaultCurrency: 'EUR',
  },
  {
    name: 'Australia',
    code: Country.Australia,
    defaultCurrency: 'AUD',
  },
  {
    name: 'Austria',
    code: Country.Austria,
    defaultCurrency: 'EUR',
  },
  {
    name: 'Canada',
    code: Country.Canada,
    defaultCurrency: 'CAD',
  },
  {
    name: 'Chile',
    code: Country.Chile,
    defaultCurrency: 'EUR',
  },
  // {
  //   name: 'Congo, The Democratic Republic of the',
  //   code: Country.DemocraticRepublicOfTheCongo,
  //   defaultCurrency: 'EUR',
  // },
  {
    name: 'Denmark',
    code: Country.Denmark,
    defaultCurrency: 'EUR',
  },
  {
    name: 'Finland',
    code: Country.Finland,
    defaultCurrency: 'EUR',
  },
  {
    name: 'France',
    code: Country.France,
    defaultCurrency: 'EUR',
  },
  {
    name: 'French Southern Territories',
    code: Country.FrenchSouthernTerritories,
    defaultCurrency: 'EUR',
  },
  {
    name: 'Germany',
    code: Country.Germany,
    defaultCurrency: 'EUR',
  },
  {
    name: 'Ireland',
    code: Country.Ireland,
    defaultCurrency: 'EUR',
  },
  {
    name: 'Italy',
    code: Country.Italy,
    defaultCurrency: 'EUR',
  },
  // {
  //   name: 'Japan',
  //   code: Country.Japan,
  //   defaultCurrency: 'EUR',
  // },
  {
    name: 'Kazakhstan',
    code: Country.Kazakhstan,
    defaultCurrency: 'EUR',
  },
  {
    name: 'Kuwait',
    code: Country.Kuwait,
    defaultCurrency: 'EUR',
  },
  {
    name: 'Lesotho',
    code: Country.Lesotho,
    defaultCurrency: 'EUR',
  },
  {
    name: 'Luxembourg',
    code: Country.Luxembourg,
    defaultCurrency: 'EUR',
  },
  // {
  //   name: 'Malta',
  //   code: Country.Malta,
  //   defaultCurrency: 'EUR',
  // },
  {
    name: 'Mexico',
    code: Country.Mexico,
    defaultCurrency: 'EUR',
  },
  {
    name: 'New Zealand',
    code: Country.NewZealand,
    defaultCurrency: 'NZD',
  },
  {
    name: 'Norway',
    code: Country.Norway,
    defaultCurrency: 'NOK',
  },
  {
    name: 'Peru',
    code: Country.Peru,
    defaultCurrency: 'EUR',
  },
  {
    name: 'Portugal',
    code: Country.Portugal,
    defaultCurrency: 'EUR',
  },
  {
    name: 'Puerto Rico',
    code: Country.PuertoRico,
    defaultCurrency: 'USD',
  },
  {
    name: 'Saint Vincent and the Grenadines',
    code: Country.SaintVincentAndTheGrenadines,
    defaultCurrency: 'EUR',
  },
  {
    name: 'Slovenia',
    code: Country.Slovenia,
    defaultCurrency: 'EUR',
  },
  {
    name: 'Spain',
    code: Country.Spain,
    defaultCurrency: 'EUR',
  },
  {
    name: 'South Africa',
    code: Country.SouthAfrica,
    defaultCurrency: 'ZAR',
  },
  {
    name: 'Switzerland',
    code: Country.Switzerland,
    defaultCurrency: 'EUR',
  },
  {
    name: 'United Arab Emirates',
    code: Country.UnitedArabEmirates,
    defaultCurrency: 'EUR',
  },
  {
    name: 'Uruguay',
    code: Country.Uruguay,
    defaultCurrency: 'EUR',
  },
];

const REGISTRATION_COUNTRIES_BY_LICENSE: Record<string, Country[]> = {
  [License.CW]: [Country.Canada],
  [License.TB]: [
    Country.Argentina,
    Country.Australia,
    Country.Austria,
    Country.Chile,
    Country.Denmark,
    Country.Finland,
    Country.France,
    Country.FrenchSouthernTerritories,
    Country.Germany,
    Country.Ireland,
    Country.Italy,
    Country.Kazakhstan,
    Country.Kuwait,
    Country.Lesotho,
    Country.Luxembourg,
    Country.Mexico,
    Country.NewZealand,
    Country.Norway,
    Country.Peru,
    Country.Portugal,
    Country.PuertoRico,
    Country.SaintVincentAndTheGrenadines,
    Country.Slovenia,
    Country.Spain,
    Country.SouthAfrica,
    Country.Switzerland,
    Country.UnitedArabEmirates,
    Country.Uruguay,
  ],
};

export const getRegistrationCountriesByLicense = (license?: string | null) => {
  const codes =
    REGISTRATION_COUNTRIES_BY_LICENSE[normalizeLicense(license)] ??
    REGISTRATION_COUNTRIES_BY_LICENSE[DEFAULT_LICENSE];

  return DEFAULT_COUNTRIES.filter(({ code }) =>
    codes.includes(code as Country)
  );
};
